import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Button, Chip, Divider, Typography, IconButton, Tabs, Tab, AppBar, Dialog, DialogTitle, DialogContent, TextField, DialogActions, DialogContentText } from '@material-ui/core';
// import Pagination from "material-ui-flat-pagination";

import HomeIcon from '@material-ui/icons/Home';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import DetailsRoundedIcon from '@material-ui/icons/DetailsRounded';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import History from '../../../history';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
    divHasilRekomendasi: {
        padding: 10,
        borderLeft: '0px solid #ccc',
        background: '#ECEFF1'
    }
});


const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
]

class HasilSupervisi extends Component {
    state = {
        error:0,
        routeParams:{
            foo: 'bar',
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            tahun: localStorage.getItem('tahun'),
            token: localStorage.getItem('jwt_token')
        },
        valueTab: 0,
        tabValue: 0,
        DialogOpen: false,
        supervisi_pengawas_id: null
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.setJudul('Hasil Supervisi');
        this.props.setLoadingBesar(true);

        this.setState({
            routeParams: {
                ...this.state.routeParams,
                jenis: (this.state.tabValue+1)
            }
        },()=>{
            this.props.getPengawas(this.state.routeParams).then((result)=>{
                // this.props.setLoadingBesar(false);
                if(this.props.pengawas.results > 0){

                    this.setState({
                        ...this.state,
                        routeParams: {
                            ...this.state.routeParams,
                            jenis: (this.state.tabValue+1),
                            pengguna_id: this.props.pengawas.rows[0].pengguna_id,
                            bukan_pengguna_id: null
                        }
                    },()=>{
                        this.props.getSupervisi(this.state.routeParams).then((result)=>{
                            this.props.setLoadingBesar(false);
    
                            this.setState({
                                routeParams: {
                                    ...this.state.routeParams,
                                    jenis: 1,
                                    bukan_pengguna_id: this.props.pengawas.rows[0].pengguna_id
                                }
                            },()=>{
                                this.props.getSupervisiPengawasLain(this.state.routeParams).then((result)=>{
                                    this.props.setLoadingBesar(false);
                                });
                            });
                        });
                        
                    })
                
                }else{
                    this.props.setLoadingBesar(false);
                }
            });
        });

    }

    konfirmasiSupervisiKonfirmasi = () => {
        this.props.setLoadingBesar(true);
        this.props.setKonfirmasiSupervisi(this.state.routeParams).then((result)=>{
            this.setState({
                ...this.state,
                DialogOpen: false
            },()=>{
                this.props.setLoadingBesar(false);
            });
        });
    }

    konfirmasiSupervisi = (supervisi_pengawas_id) => {
        // console.log(supervisi_pengawas_id);
        this.setState({
            ...this.state,
            DialogOpen: true,
            routeParams: {
                ...this.state.routeParams,
                supervisi_pengawas_id: supervisi_pengawas_id,
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            }
        },()=>{
            // this.props.setKonfirmasiSupervisi(this.state.routeParams);
        });
    }

    handleChangeTab = (e,value) => {
        this.props.setLoadingBesar(true);
        this.setState({
            ...this.state,
            tabValue: value,
            routeParams: {
                ...this.state.routeParams,
                jenis: (value+1),
                bukan_pengguna_id: null
            }
        },()=>{
            this.props.getSupervisi(this.state.routeParams).then((result)=>{
                this.props.setLoadingBesar(false);

                this.setState({
                    routeParams: {
                        ...this.state.routeParams,
                        jenis: 1,
                        bukan_pengguna_id: this.props.pengawas.rows[0].pengguna_id
                    }
                },()=>{
                    this.props.getSupervisiPengawasLain(this.state.routeParams).then((result)=>{
                        this.props.setLoadingBesar(false);
                    });
                });
            });
        });
    }

    handleChangeKeterangan = (e) => {
        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                keterangan: e.currentTarget.value
            }
        },()=>{
            // console.log(this.state);
        });
    }

    handleClose = () => {
        this.setState({
            DialogOpen: false
        });
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <div>
                    <Dialog open={this.state.DialogOpen} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Konfirmasi Supervisi Pengawas</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Konfirmasi bahwa pengawas yang bersangkutan benar telah melakukan kunjungan supervisi ke sekolah Anda
                            </DialogContentText>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                value={this.state.routeParams.keterangan}
                                label="Keterangan (Kosongkan bila tidak ada)"
                                // placeHolder="Kosongkan bila tidak ada keterangan tambahan"
                                onChange={this.handleChangeKeterangan}
                                fullWidth
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Batal
                            </Button>
                            <Button onClick={this.konfirmasiSupervisiKonfirmasi} color="primary">
                                Konfirmasi
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div style={{width: '100%', padding: 10}} className="konten-utama">
                            <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                                <Chip
                                    icon={<HomeIcon/>}
                                    label=""
                                    className={this.props.classes.chip}
                                    color="primary"
                                    style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                    onClick={()=>{this.goTolink('/Beranda')}}
                                />
                                <Chip
                                    label={"> Hasil Supervisi"}
                                    className={this.props.classes.chip}
                                    color="secondary"
                                    // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                    style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                                />
                            </div>
                            {this.props.pengawas.results > 0 &&
                            <div>
                                <Paper className="p-16 m-8">
                                    <Typography variant="h6" style={{color:'#1976d2'}}>
                                        Identitas Pengawas
                                    </Typography>
                                    <Divider/>
                                    <br/>
                                    <Grid container>
                                        <Grid items xs={12} sm={6}>
                                            Nama: <b>{this.props.pengawas.rows[0].nama}</b>
                                            <br/>
                                            NUPTK: <b>{this.props.pengawas.rows[0].nuptk}</b>
                                        </Grid>
                                        <Grid items xs={12} sm={6}>
                                            Jenis PTK: <b>{this.props.pengawas.rows[0].bidang_studi_id_str}</b>
                                            <br/>
                                            Wilayah: <b>{this.props.pengawas.rows[0].kabupaten}, {this.props.pengawas.rows[0].provinsi}</b>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <AppBar position="static">
                                    <Tabs value={this.state.tabValue} onChange={this.handleChangeTab}>
                                        <Tab label="Riwayat Kunjungan" />
                                        <Tab label="Rencana Kunjungan" />
                                    </Tabs>
                                </AppBar>
                            {/* <Paper className="p-16 m-8" style={{marginBottom:'10px'}}> */}
                                {/* this is where the looping starts */}
                                {this.props.supervisi.results === 0 && 
                                <Paper className="p-8 m-8">
                                    <Typography variant="caption">
                                        {this.state.tabValue === 0 && <span>Belum ada data kunjungan supervisi</span>}
                                        {this.state.tabValue === 1 && <span>Belum ada data rencana supervisi</span>}
                                    </Typography>
                                </Paper>
                                }
                                {this.props.supervisi.rows.map((option)=>{
                                    return (
                                        <Paper className={"m-8 p-16 " + classes.paperList}>
                                            <Grid container spacing={8}>
                                                <Grid container>
                                                    <Grid item xs={8}>
                                                        <Grid container>
                                                            <Grid items xs={12} sm={12}>
                                                                <Typography variant="body1" style={{color:'#1976d2', fontWeight:'bold',fontSize: '17px'}}>
                                                                    {/* Tes */}
                                                                    {Number(option.jenis_kunjungan_id) === 2 && <span>Rencana </span>} Supervisi { new Date(option.tanggal).getDate() } { bulan[new Date(option.tanggal).getMonth()] } { new Date(option.tanggal).getFullYear() } 
                                                                </Typography>
                                                            </Grid>
                                                            <Grid items xs={12} sm={12}>
                                                                {/* <Typography variant="caption">Sekolah yang dikunjungi: </Typography> */}
                                                                {/* <Typography variant="caption">Sekolah yang dikunjungi: {option.nama} ({option.npsn})</Typography> */}
                                                                {/* <Typography variant="caption">0000-00-00</Typography> */}
                                                                <Typography variant="caption">{option.create_date}</Typography>
                                                            </Grid>
                                                            <Grid items xs={12} sm={12}>
                                                                {/* <Typography variant="caption">Sekolah yang dikunjungi: </Typography> */}
                                                                {/* <Typography variant="caption">Sekolah yang dikunjungi: {option.nama} ({option.npsn})</Typography> */}
                                                                {/* <Typography variant="caption">0000-00-00</Typography> */}
                                                                <Typography variant="subheading">{option.hasil_pengamatan}</Typography>
                                                                <br/>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={4} style={{textAlign:'right'}}>
                                                        <IconButton onClick={()=>History.push('/DetailHasilSupervisi/'+option.supervisi_pengawas_id+'/'+Number(option.jenis_kunjungan_id))}>
                                                            <ListAltIcon />
                                                        </IconButton>
                                                        {Number(option.jenis_kunjungan_id) === 1 &&
                                                        <span>
                                                            {option.konfirmasi_supervisi_id !== null && 
                                                            <span>
                                                                <Button disabled="disabled" onClick={()=>this.konfirmasiSupervisi(option.supervisi_pengawas_id)}>
                                                                    <CheckBoxOutlinedIcon /> &nbsp;Konfirmasi
                                                                </Button>
                                                                <Typography variant="caption">
                                                                    Kunjungan supervisi ini telah dikonfirmasi
                                                                </Typography>
                                                            </span>
                                                            }
                                                            {option.konfirmasi_supervisi_id === null && 
                                                            <Button onClick={()=>this.konfirmasiSupervisi(option.supervisi_pengawas_id)}>
                                                                <CheckBoxOutlinedIcon /> &nbsp;Konfirmasi
                                                            </Button>
                                                            }
                                                        </span> 
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid items xs={12} sm={12} className={classes.divHasilRekomendasi} style={{padding:'0px',paddingTop:'0px'}}>
                                                    <Grid container>
                                                    {option.children.map((optionChildren)=>{
                                                        return (
                                                            <Grid items xs={12} sm={3} className={classes.divHasilRekomendasi} style={{borderRight:'1px solid #ccc', borderBottom: '1px solid #ccc'}}>
                                                                <Grid container >
                                                                    <Grid item xs={10}>
                                                                        <Typography variant="caption">
                                                                            {optionChildren.nama_formulir}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={2} style={{textAlign:'right'}}>
                                                                        {Number(optionChildren.terisi) === 1 && <CheckCircleIcon style={{color:'green'}}/>}
                                                                        {Number(optionChildren.terisi) === 0 && <CancelIcon style={{color:'red'}}/>}
                                                                        {/* {!optionChildren.hasil_pengamatan && !optionChildren.analisis_hasil && !optionChildren.solusi && !optionChildren.aktivitas_pendampingan && <CancelIcon style={{color:'red'}} />} */}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        );
                                                    })}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    )
                                })}
                            {/* </Paper> */}
                            </div>
                            }
                            {this.props.pengawas.results < 1 &&
                            <div>
                                <Paper className="p-8 m-8">
                                    <Typography variant="subheading">
                                        Sekolah Anda belum memiliki pengawas untuk tahun ajaran ini
                                    </Typography>
                                </Paper>
                            </div>
                            }
                            <br/>
                            <Divider/>
                            <br/>
                            <Paper className="p-8 m-8">
                                <Typography variant="subheading">
                                    Riwayat Kunjungan oleh Pengawas Lain
                                </Typography>
                                <Divider/>
                                <br/>
                                {this.props.supervisi_pengawas_lain.rows.map((option)=>{
                                    return (
                                        <Paper className={"p-16 mb-8"}>
                                            <Grid container spacing={8}>
                                                <Grid container>
                                                    <Grid item xs={10}>
                                                        <Grid container>
                                                            <Grid items xs={12} sm={12}>
                                                                <Typography variant="body1" style={{color:'#1976d2', fontWeight:'bold',fontSize: '15px'}}>
                                                                    {/* Tes */}
                                                                    {Number(option.jenis_kunjungan_id) === 2 && <span>Rencana </span>} Supervisi { new Date(option.tanggal).getDate() } { bulan[new Date(option.tanggal).getMonth()] } { new Date(option.tanggal).getFullYear() }
                                                                    &nbsp;oleh {option.nama} 
                                                                </Typography>
                                                            </Grid>
                                                            <Grid items xs={12} sm={12}>
                                                                <Typography variant="caption">{option.create_date}</Typography>
                                                            </Grid>
                                                            <Grid items xs={12} sm={12}>
                                                                <Typography variant="caption">{option.hasil_pengamatan}</Typography>
                                                                <br/>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={2} style={{textAlign:'right'}}>
                                                        <IconButton>
                                                            <DetailsRoundedIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    )
                                })}
                            </Paper>
                        </div>
                    </FuseAnimate>
                    </div>
                }
            />
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        setJudul: Actions.setJudul,
        getProsesRapor: Actions.getProsesRapor,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah,
        getSupervisi: Actions.getSupervisi,
        getSupervisiPengawasLain: Actions.getSupervisiPengawasLain,
        getPengawas: Actions.getPengawas,
        setKonfirmasiSupervisi: Actions.setKonfirmasiSupervisi
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu, Supervisi }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        rapor_mutu_radar: RaporMutu.rapor_mutu_radar,
        data_tahun: RaporMutu.data_tahun,
        data_wilayah: RaporMutu.data_wilayah,
        supervisi: Supervisi.supervisi,
        supervisi_pengawas_lain: Supervisi.supervisi_pengawas_lain,
        pengawas: Supervisi.pengawas
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(HasilSupervisi)));



// WEBPACK FOOTER //
// ./src/main/content/Notifikasi/HasilSupervisi.js